import { useQuery } from 'react-query';
import { Profile } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/profile.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { getClient } from 'src/util/mdello-instance';
import { useNotification } from '../../../../providers/notificationsProvider';

const fetchCustomerProfileData = async (profileId: string): Promise<Profile | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id || !profileId) {
    return undefined;
  }

  const data = await getClient()?.getProfileById(currentProject?._id, profileId);

  // const data = await fetchCustomerProfile(currentProject._id, profileId);

  return data;
};

export const useGetCustomerProfile = (profileId: string) => {
  const { notify } = useNotification();

  return useQuery(
    [QueryKey.CUSTOMER_PROFILE, profileId],
    () => fetchCustomerProfileData(profileId),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
